export const SET_PENDING_DEAL_OFFER_ACTION = 'SET_PENDING_DEAL_OFFER_ACTION';
export const CLEAR_PENDING_DEAL_OFFER_ACTION = 'CLEAR_PENDING_DEAL_OFFER_ACTION';
export const SET_APPLIED_DEAL_ROW_UPDATE = 'SET_APPLIED_DEAL_ROW_UPDATE';
export const CLEAR_APPLIED_DEAL_ROW_UPDATE = 'CLEAR_APPLIED_DEAL_ROW_UPDATE';
